import {atom} from 'recoil';

export const alertState = atom({
    key: 'alertState',
    default: {
        active: false,
        text: '',
        confirmButtonText:'확인'
    }
});